module.exports = __webpack_public_path__ + "de4112297ce453ea785d0f032b885215.pdf";